import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import Select from "../common/selectcustom";
import { getLPRlist, getlprdevice } from "../../services/lpr";
import Showimage from "../wms/modalshowimage";
import DatePicker from "react-datepicker";
import moment from "moment";
import BranchContext from "../context/branch";
import Input from "../wms/input";
import Renderregister from "../wms/rendertruckenvent";

import ScrollToTop from "../common/ScrollToTop";
import { Label } from "reactstrap";
const Registerlist = () => {
  const { currentBranch } = useContext(BranchContext);
  //   const [isDownload, setisDownload] = useState(true);
  const [register, setregister] = useState([]);
  const [devicelist, setdevicelist] = useState([]);
  const [deviceid, setdeviceid] = useState(0);
  const [search, setSearch] = useState("");
  const [name, setname] = useState("");
  const [header, setheader] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [isOpen, setisOpen] = useState(false);
  const [endDate, setEndDate] = useState(new Date());
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, settotal] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(25);
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getlprdevice(
        currentBranch && currentBranch._id
      );

      if (result.status === "success") {
        setdevicelist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    setregister([]);
  }, [startDate, endDate, currentBranch, search, pageSize, deviceid]);

  useEffect(() => {
    if (!currentBranch) return;

    setLoading(true);
    setError(false);
    const loadData = async () => {
      const { data: result } = await getLPRlist(
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        currentBranch && currentBranch._id,
        deviceid,
        search,
        pageSize,
        pageNumber
      );
      if (result.status === "success") {
        settotal(result.data.total);
        setregister((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
      }
    };
    loadData();
  }, [
    startDate,
    endDate,
    currentBranch,
    search,
    pageSize,
    pageNumber,
    deviceid,
  ]);

  const handleChangStartDate = (event) => {
    setStartDate(event);
    setPageNumber(1);
  };
  const handleChangEndDate = (event) => {
    setEndDate(event);
    setPageNumber(1);
  };

  const onhandleChangeDeviceId = (event) => {
    setdeviceid(event.currentTarget.value);
    setPageNumber(1);
  };

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handleTextchange = (event) => {
    setname(event.target.value);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setSearch(name);
      setPageNumber(1);
    }
  };
  const handleSearchDrinvenClick = () => {
    setSearch(name);
    setPageNumber(1);
  };
  const handleOnclick = (event, header) => {
    setImageUrl(event);
    setheader(header);
    setisOpen(true);
  };
  const handelClose = () => {
    setisOpen(false);
  };
  return (
    <>
      <Showimage
        isOpen={isOpen}
        header={header}
        onCancel={handelClose}
        list={imageUrl}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-auto">
            <div className="m-2">
              <Label>จากวันที่</Label>
              <div className="mt-2" >
                <DatePicker
                  className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={handleChangStartDate}
                />
              </div>
            </div>
          </div>
          <div className="col-auto">
            <div className="m-2">
            <Label>ถึงวันที่</Label>
              <div className="">
                <DatePicker
                  className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={handleChangEndDate}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-3 mt-2">
          <Label>LPR No</Label>
            <div className="form-group">
              <Select
                data={devicelist}
                value={deviceid}
                textProperty="name"
                valueProperty="_id"
                onChange={onhandleChangeDeviceId}
              />
            </div>        
          </div>
        <div className="col-lg-3 col-sm-6 col-md-6 col-xs-12 mt-3">
          <div className="form-group">
            <Input
              name="weightno"
              value={name}
              placeholder="ทะเบียนรถ"
              onChange={handleTextchange}
              onKeyPress={handleKeyPress}
              onClick={handleSearchDrinvenClick}
              search="ค้นหา"
            />
          </div>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-6 col-xs-12 mt-3">
          <div>&nbsp;</div>
          <button className="btn btn-success ">Download To Excel</button>
        </div>
      </div>

      

    
      <p className="text-success">
        แสดงข้อมูล {register ? register.length : 0} รายการ / {total} บนระบบ
      </p>

      {<ScrollToTop />}
      <Renderregister
        list={register}
        loading={loading}
        onClick={handleOnclick}
        error={error}
        lastBookElementRef={lastBookElementRef}
      />

      <div>{loading && "Loading..."}</div>
      <div>{error && "Error"}</div>
      </div>
    </>
  );
};

export default Registerlist;
